import { render, staticRenderFns } from "./SendResetForm.vue?vue&type=template&id=d5499ec0"
import script from "./SendResetForm.vue?vue&type=script&lang=js"
export * from "./SendResetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports